import { EventBus } from 'core-components/classes/events/Bus'

export enum EDialerEventBusEvent {
  onChangeDialerVisibility = 'onChangeDialerVisibility',
  onChangeLine = 'onChangeLine',
  onForceSearch = 'onForceSearch',
}

export const dialerEventBus = new EventBus(
  [
    EDialerEventBusEvent.onChangeDialerVisibility,
    EDialerEventBusEvent.onChangeLine,
    EDialerEventBusEvent.onForceSearch,
  ],
  'Dialer'
)
